import { render, staticRenderFns } from "./OnBoard.vue?vue&type=template&id=53dc6544"
import script from "./OnBoard.vue?vue&type=script&lang=js"
export * from "./OnBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53dc6544')) {
      api.createRecord('53dc6544', component.options)
    } else {
      api.reload('53dc6544', component.options)
    }
    module.hot.accept("./OnBoard.vue?vue&type=template&id=53dc6544", function () {
      api.rerender('53dc6544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/RecruitProgress/HR/OnBoard.vue"
export default component.exports